import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import auth from '@/store/modules/auth'
import client from '@/store/modules/client'
import administration from '@/store/modules/administration'
import ui from '@/store/modules/ui'
import { IAuthState } from './modules/auth/state'
import { IClientState } from './modules/client/state'
import { IUiState } from './modules/ui/state'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloError } from '@/models/alo/AloError'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { StateItem } from '@/models/alo/StateItem'
import { AloBase } from '@/models/alo/AloBase'
import  types from '@/store/all-action-types'
import cloneDeep from 'clone-deep'
import { IAdministrationState } from './modules/administration/state'
import { CommitAction } from '@/enum/CommitAction'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export interface IRootState {  
  auth: IAuthState
  client:IClientState  
  administration:IAdministrationState
  ui:IUiState
}

const store = new Vuex.Store<IRootState>({    
  modules: {
    auth,
    client,
    administration,
    ui
  },  
  strict: debug
})

export default store

const initialStateCopy = cloneDeep(store.state)

export function resetState() {        
  const state = cloneDeep(initialStateCopy) as IRootState     
  state.auth.authStatus = store.state.auth.authStatus
  state.auth.redirectPath = store.state.auth.redirectPath  
  store.replaceState(state)  
}

export function loadInitalData() {
  //store.dispatch(types.ROOM_SERVICES_DATAS_ENSURE)
}

export const emptyAction = <T,TS>(context: ActionContext<TS, IRootState>,
  resquestCommit:string,
  successCommit:string,
  errorCommit:string,
  emptyRequest: () => AxiosPromise<AlrContainer<T>>,
  commit:CommitAction = CommitAction.listAndDic ) => {
  return new Promise<T>((resolve, reject) => {
    context.commit(resquestCommit)
    emptyRequest()
      .then(resp => {        
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          if(commit == CommitAction.listAndDic) context.commit(successCommit, item)
          else if(commit == CommitAction.dicOnly) context.commit(`${successCommit}_DIC`, item)
          resolve(item)            

        } else {            
          if(commit != CommitAction.none) context.commit(errorCommit,(resp.data.data as AloError).errorMessage)
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {  
        if(err.response)  {
          if(commit != CommitAction.none) context.commit(errorCommit,(err.response?.data?.data as AloError)?.errorMessage ?? err)
          reject((err.response?.data?.data as AloError)?.errorMessage ?? err)
        }        
        if(commit != CommitAction.none) context.commit(errorCommit)
        reject(err)
      })
  })
}

export const payloadAction = <T,TS>(context: ActionContext<TS, IRootState>,
    resquestCommit:string,
    successCommit:string,
    errorCommit:string,
    payloadRequest: (payload:any) => AxiosPromise<AlrContainer<T>>, 
    payload:any,
    commit:CommitAction = CommitAction.listAndDic,
    addPayloadToCommit = false,
  ) => {
  return new Promise<T>((resolve, reject) => {
    if(commit) addPayloadToCommit?context.commit(resquestCommit,payload):context.commit(resquestCommit)
    payloadRequest(payload)
      .then(resp => {
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          if(commit == CommitAction.listAndDic) context.commit(successCommit, addPayloadToCommit?{item,payload}:item)
          else if(commit == CommitAction.dicOnly) context.commit(`${successCommit}_DIC`, addPayloadToCommit?{item,payload}:item)
          resolve(item)            

        } else {            
          if(commit != CommitAction.none) addPayloadToCommit?context.commit(errorCommit,payload):context.commit(errorCommit,(resp.data.data as AloError).errorMessage)
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {   
        if(err.response)  {
          if(commit != CommitAction.none) addPayloadToCommit?context.commit(errorCommit,payload):context.commit(errorCommit,(err.response?.data?.data as AloError)?.errorMessage ?? err)
          reject((err.response?.data?.data as AloError)?.errorMessage ?? err)
        }
        else{
          if(commit != CommitAction.none) addPayloadToCommit?context.commit(errorCommit,payload):context.commit(errorCommit)
          reject(err)
        }
      })
  })
}

export const actionEnsure = <T,TS>(context: ActionContext<TS, IRootState>,resquestAction:string, stateItemToCheck:StateItem<any>|null, id?:number ) => {    
  if(!stateItemToCheck || stateItemToCheck.expireAt < new Date() || (id && !(stateItemToCheck.item as AloBase).detailLoaded)) {    
    return id?context.dispatch(resquestAction,id):context.dispatch(resquestAction)
  }
  return new Promise<T>((resolve, reject) => {
    resolve(stateItemToCheck.item)
  })
}